<template>
  <div class="single-wrap">
    <div class="single-header"><a class="logo-section" href="/">
      <span class="datawill-logo-text2"></span>
    </a>
    </div>
    <div class="single-body">
      <div class="single-card">
        <div class="single-card-title">
          <a href='/' class="m-5">
            <span class="datawill-logo-text2">注册用户</span>
          </a></div>
        <div>
          <div class="form-group">
            <label class="form-label"> 邀请码 </label>
            <div thysize="lg" class="thy-input form-control">
              <span class="input-label input-label-lg"></span>
              <input class="form-control-lg form-control" placeholder="邀请码" v-model="addForm.invite">
            </div>
          </div>

          <div class="form-group">
            <label class="form-label"> 用户名 </label>
            <div thysize="lg" class="thy-input form-control">
              <span class="input-label input-label-lg"></span>
              <input class="form-control-lg form-control" placeholder="请输入用户名"
                     v-model="addForm.username">
            </div>
          </div>

          <div class="form-group">
            <label class="form-label"> 电子邮箱 </label>
            <div thysize="lg" class="thy-input form-control">
              <span class="input-label input-label-lg"></span>
              <input class="form-control-lg form-control" v-model="addForm.email"
                     placeholder="电子邮箱地址"></input>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label"> 密码 </label>
            <div thysize="lg" class="thy-input form-control">
              <span class="input-label input-label-lg"></span>
              <input class="form-control-lg form-control" placeholder="请输入密码" type="password"
                     v-model="addForm.password">
            </div>
          </div>

          <div class="form-group">
            <label class="form-label"> 密码确认 </label>
            <div thysize="lg" class="thy-input form-control">
              <span class="input-label input-label-lg"></span>
              <input class="form-control-lg form-control" placeholder="请再次输入密码" type="password"
                     v-model="addForm.password">
            </div>
          </div>


          <div class="form-group">
            <label class="form-label"> 验证码 </label>
            <div thysize="lg" class="thy-input form-control">
              <span class="input-label input-label-lg"></span>
              <input class="form-control-lg  form-control" placeholder="请输入验证码"
                     v-model="addForm.validateCode">
              <div class="">
                <el-image :src="captcha_url" @click="get_captcha"/>
              </div>
            </div>
          </div>

        </div>

        <div class="mt-3">
          <div></div>
        </div>
        <div class="single-card-actions form-group">
          <div class="form-group-footer form-group-footer-align-left">
            <div class="btn-pair form-footer-actions">
              <button class="btn-block single-btn lg-btn btn btn-primary btn-square" v-on:click="handleLogin">创建账号
              </button>
              <div class="single-card-actions-desc"> 或 <a href="javascript:;" @click="handleGoBack">返回登录</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../api/rest'
import util from '../../api/util'

export default {
  name: 'Register',
  data() {
    return {
      // 新增界面数据
      addForm: {
        name: '',
        phone: '',
        painpwd: '',
        password: '',
        email: '',
        roles: ['USER'],
        validateCode: ''
      },
      isMobile: false,
      addLoading: false,
      captcha_url: api.setting.getApiUrl() + "/captcha",
      rules: util.setting.getRules()
    }
  },
  methods: {
    validatePass(rule, value, callback) {
      if (this.addForm.password !== '') {
        this.$refs.addForm.validateField('password')
      } else {
        callback()
      }
    },
    validatePass2(rule, value, callback) {
      if (value !== this.addForm.painpwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    },
    get_captcha() {
      this.captcha_url = api.setting.getApiUrl() + "/captcha?id=" + Math.random();
    },
    handleRegist() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true
          let para = Object.assign({}, this.addForm)
          let api_url = "/register?code=" + this.addForm.validateCode
          api.remote.doPost(para, api_url).then((res) => {
            this.$message({
              message: res.message,
              title: res.title,
              type: res.status
            });
            if (res.status == 'success') {
              this.handleLogin()
            }
            this.addLoading = false
          }).catch((res) => {
            this.addLoading = false
            api.handError.action(this, res)
          })
        }
      })
    },
    handleLogin() {
      let api_url = '/session?code=' + this.addForm.validateCode
      let para = {
        username: this.addForm.name,
        password: this.addForm.painpwd,
        code: this.addForm.validateCode
      }
      api.remote.doPost(para, api_url).then((resp) => {
        let data = resp.item
        api.profile.setUser(data)
        window.location = '/#/default'
        window.location.reload()
      }).catch((e) => {
        if (e.code === 403) {
          this.$message({
            message: "验证码错误",
            type: 'error'
          })
        } else {
          this.$message({
            message: e.message,
            type: 'error'
          })
        }
      })
    },
    handleGoBack() {
      window.location = '#/login'
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  },
  mounted() {
    this.$message({
      message: '系统仅对被邀请的用户开放，无邀请码无法注册，谢谢。',
      type: 'warning'
    })
    this.isMobile = this._isMobile()
    if (this.isMobile) {
      this.$message({
        message: '请使用PC浏览器注册用户',
        type: 'warning'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Register.vue?49f0acea